module.exports = __webpack_public_path__ + "static/media/collection.22c13800.svg";